import { render } from "./AlertDetailModal.vue?vue&type=template&id=5bbadca8&scoped=true&ts=true"
import script from "./AlertDetailModal.vue?vue&type=script&lang=ts"
export * from "./AlertDetailModal.vue?vue&type=script&lang=ts"

import "./AlertDetailModal.vue?vue&type=style&index=0&id=5bbadca8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbadca8"]])

export default __exports__